import { CodeSystem } from "context/elasticsearch/types";

const clinicalCodesystems = new Set([
  CodeSystem.Icd10,
  CodeSystem.Icpc2,
  CodeSystem.Nkpk,
  CodeSystem.Phbu
]);

const isClinicalCodesystem = (codeSystem: CodeSystem) => {
  return clinicalCodesystems.has(codeSystem);
};

export default isClinicalCodesystem;
